import { Background } from '@linearb/linui-common/marketing/Background';
import { useEffect } from 'react';
import axios from 'common/requester';
import { LINB_API } from 'common/constants/api-urls';
import { logOut } from 'common/services/auth.service';

const Logout = () => {
  useEffect(() => {
    async function doLogout() {
      try {
        await axios.get(LINB_API.TOKEN.LOGOUT, { withCredentials: true });
      } catch (e) {
        // Optionally log error or show notification
      } finally {
        logOut();
      }
    }
    doLogout();
  }, []);

  return (
    <Background
      sx={{
        height: '100vh',
        width: '100vw',
        position: 'relative'
      }}
    >
      Logging out...
    </Background>
  );
};

export default Logout;
